export default __webpack_public_path__ + "static/media/movieinfo.b0214b90.jpg";